'use client';

import { Box, Button, SystemIcon, Typography } from '@wishket/design-system';
import { usePathname, useRouter } from 'next/navigation';
import { twJoin } from 'tailwind-merge';

import { SubscribedSuccessTooltip } from './SubscriptionSuccessTooltip';

import { useAuthorProfileInfo, useAuthorSubscription } from '@/entities/author';
import { useAuth, useTimedOpen } from '@/shared/hooks';
import { PATH } from '@/shared/constants';

interface AuthorSubscriptionButtonProps {
  authorId: number;
}

//TODO 다른 작가 구독 버튼도 Shared를 사용하도록 refactoring하기
const AuthorSubscriptionButton = ({
  authorId,
}: AuthorSubscriptionButtonProps) => {
  const { data } = useAuthorProfileInfo({ authorId });
  const isSubscribed = data?.isSubscribed ?? false;
  const { mutate: toggleSubscription } = useAuthorSubscription();
  const { isAuth } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const [isTooltipOpen, openTooltip, closeTooltip] = useTimedOpen();

  const toggleTooltipOpen = (isSubscribeAction: boolean) => {
    if (isSubscribeAction) {
      openTooltip();
    } else {
      closeTooltip();
    }
  };

  const handleClick = () => {
    if (!isAuth) {
      router.push(`${PATH.AUTH_LOGIN}?next=${pathname}`);
      return;
    }

    toggleSubscription(authorId);
    toggleTooltipOpen(!isSubscribed);
  };

  return (
    <Box className="relative">
      <Button
        size="sm"
        variant={isSubscribed ? 'outlined' : 'solid'}
        className="flex items-center gap-1"
        onClick={handleClick}
      >
        <SystemIcon
          name="small_bell"
          solid={isSubscribed}
          className={twJoin(
            'shrink-0',
            isSubscribed ? 'text-primary' : 'text-w-white'
          )}
        />
        <Typography variant="body2" className="shrink-0">
          알림
        </Typography>
      </Button>
      {isTooltipOpen && <SubscribedSuccessTooltip />}
    </Box>
  );
};

export default AuthorSubscriptionButton;
